export default "__VITE_ASSET__BwsQIKOr__"